import ajax from '@/modules/ajax';

export default class Voting {
  constructor(options) {
    this.wrapper = $(options.wrapper);
    this.dislikeButton = this.wrapper.find('.voting__dislike');
    this.likeButton = this.wrapper.find('.voting__like');
    this.options = options;
  }

  create() {
    this.binds();
  }

  binds() {
    const that = this;

    this.likeButton.on('click', 'a', function () {
      that.onClick(this);
    });

    if (this.dislikeButton.length) {
      this.dislikeButton.on('click', 'a', function () {
        that.onClick(this);
      });
    }
  }

  onClick(button) {
    ajax({
      body: { value: button.getAttribute('data-value'), voteable_type: this.options.voteableType },
      done: (json) => {
        const wrapper = $(button).closest(this.options.wrapper);

        wrapper.find('.voting__like .voting_button').toggleClass('voting_button--active', json.status === 'positive');
        wrapper.find('.voting__dislike .voting_button').toggleClass('voting_button--active', json.status === 'negative');
        wrapper.find('[data-voting-score]').text(json.score);
      },
      method: 'PATCH',
      url: '/votes/' + button.getAttribute('data-voteable-id'),
    });

  }
}
